module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/motherfatherson.68730eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/motherfatherson.jpg
// module id = Tncm
// module chunks = 0